import { render, staticRenderFns } from "./DetailBarangRusak.vue?vue&type=template&id=ecb2ea72&scoped=true&"
import script from "./DetailBarangRusak.vue?vue&type=script&lang=js&"
export * from "./DetailBarangRusak.vue?vue&type=script&lang=js&"
import style0 from "./DetailBarangRusak.vue?vue&type=style&index=0&id=ecb2ea72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb2ea72",
  null
  
)

export default component.exports